export function getIconClassFromMimeType(mimeType) {
    // https://gist.github.com/guedressel/0daa170c0fde65ce5551
    const mapping = {
        // Images
        'image'                                                                     : 'fa fa-file-image-o',
        // Audio
        'audio'                                                                     : 'fa fa-file-audio-o',
        // Video
        'video'                                                                     : 'fa fa-file-video-o',
        // Documents
        'application/pdf'                                                           : 'fa fa-file-pdf-o',
        'application/msword'                                                        : 'fa fa-file-word-o',
        'application/vnd.ms-word'                                                   : 'fa fa-file-word-o',
        'application/vnd.oasis.opendocument.text'                                   : 'fa fa-file-word-o',
        'application/vnd.openxmlformats-officedocument.wordprocessingml'            : 'fa fa-file-word-o',
        'application/vnd.ms-excel'                                                  : 'fa fa-file-excel-o',
        'application/vnd.openxmlformats-officedocument.spreadsheetml'               : 'fa fa-file-excel-o',
        'application/vnd.oasis.opendocument.spreadsheet'                            : 'fa fa-file-excel-o',
        'application/vnd.ms-powerpoint'                                             : 'fa fa-file-powerpoint-o',
        'application/vnd.openxmlformats-officedocument.presentationml'              : 'ffa fa-file-powerpoint-o',
        'application/vnd.oasis.opendocument.presentation'                           : 'fa fa-file-powerpoint-o',
        'text/plain'                                                                : 'fa fa-file-text-o',
        'text/html'                                                                 : 'fa fa-file-code-o',
        'application/json'                                                          : 'fa fa-file-code-o',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'   : 'fa fa-file-word-o',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'         : 'fa fa-file-excel-o',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' : 'fa fa-file-powerpoint-o',
        // Archives
        'application/gzip'                                                          : 'fa fa-file-zip-o',
        'application/zip'                                                           : 'fa fa-file-zip-o',
        'application/x-zip-compressed'                                              : 'fa fa-file-zip-o',
        // Misc
        'application/octet-stream'                                                  : 'fa fa-file-o',
    }

    let iconClass = mapping[mimeType] ? mapping[mimeType] : mapping[mimeType.split('/')[0]]

    return iconClass ? iconClass : 'fa fa-file-o'
}